export const jobTitles = [
  { codigo: '600', nombre: 'Abogado' },
  { codigo: '400', nombre: 'Acomodador' },
  { codigo: '602', nombre: 'Actor/Cantante/Animador' },
  { codigo: '603', nombre: 'Administrador De Empresas' },
  { codigo: '401', nombre: 'Albañil/Trab.Construcción' },
  { codigo: '604', nombre: 'Arqueólogo' },
  { codigo: '605', nombre: 'Arquitecto/Urbanista' },
  { codigo: '402', nombre: 'Artesano' },
  { codigo: '702', nombre: 'Artista' },
  { codigo: '606', nombre: 'Asistente Social' },
  { codigo: '200', nombre: 'Auxiliar De Oficina' },
  { codigo: '607', nombre: 'Bibliotecario / Bibliotecólogo' },
  { codigo: '703', nombre: 'Bombero' },
  { codigo: '300', nombre: 'Cajero' },
  { codigo: '500', nombre: 'Cambista' },
  { codigo: '403', nombre: 'Carnicero' },
  { codigo: '704', nombre: 'Cartero' },
  { codigo: '501', nombre: 'Chofer/Cobrador Transporte Publico' },
  { codigo: '608', nombre: 'Científico' },
  { codigo: '301', nombre: 'Cobrador' },
  { codigo: '302', nombre: 'Comerciante' },
  { codigo: '609', nombre: 'Compositor/Músico' },
  { codigo: '404', nombre: 'Conductor' },
  { codigo: '206', nombre: 'Conserje' },
  { codigo: '107', nombre: 'Consultor/Asesor' },
  { codigo: '610', nombre: 'Contador' },
  { codigo: '705', nombre: 'Crupier' },
  { codigo: '706', nombre: 'Decorador/Diseñador' },
  { codigo: '611', nombre: 'Dentista/Odontólogo' },
  { codigo: '707', nombre: 'Detective Privado' },
  { codigo: '708', nombre: 'Digitador/Taquígrafo' },
  { codigo: '637', nombre: 'Dueño/Socio/Accionista Negocio Formal' },
  { codigo: '612', nombre: 'Ecologista' },
  { codigo: '613', nombre: 'Economista' },
  { codigo: '405', nombre: 'Electricista/Técnico De Elect.' },
  { codigo: '614', nombre: 'Electrotécnico' },
  { codigo: '709', nombre: 'Empleado De Iglesia' },
  { codigo: '100', nombre: 'Empleado Del Sector Público' },
  { codigo: '711', nombre: 'Empleado Hotel/Restaurant/Turismo' },
  { codigo: '101', nombre: 'Empleado/Asistente Oficina O Empresa' },
  { codigo: '710', nombre: 'Encuestador' },
  { codigo: '109', nombre: 'Enfermera/Obstetriz' },
  { codigo: '616', nombre: 'Estadístico' },
  { codigo: '617', nombre: 'Farmacólogo/Laboratorista' },
  { codigo: '618', nombre: 'Filósofo' },
  { codigo: '102', nombre: 'Funcionario Partido Político' },
  { codigo: '103', nombre: 'Funcionario Público' },
  { codigo: '619', nombre: 'Grafólogo' },
  { codigo: '620', nombre: 'Historiador' },
  { codigo: '621', nombre: 'Ingeniero' },
  { codigo: '104', nombre: 'Jefe/Gerente/Alto Mando' },
  { codigo: '110', nombre: 'Laboratorista' },
  { codigo: '622', nombre: 'Licenciado En Computación' },
  { codigo: '623', nombre: 'Licenciado En Turismo' },
  { codigo: '624', nombre: 'Lingüista / Literato' },
  { codigo: '712', nombre: 'Maquillador/Estilista' },
  { codigo: '625', nombre: 'Matemático' },
  { codigo: '406', nombre: 'Mecánico' },
  { codigo: '202', nombre: 'Mensajero' },
  { codigo: '713', nombre: 'Modelo' },
  { codigo: '626', nombre: 'Médico/Cirujano' },
  { codigo: '627', nombre: 'Nutricionista' },
  { codigo: '407', nombre: 'Obrero/Trabajador Industrial' },
  { codigo: '203', nombre: 'Operador Máquina De Oficina' },
  { codigo: '714', nombre: 'Operadores De Radio Y Tv' },
  { codigo: '408', nombre: 'Operario De Maquinaria' },
  { codigo: '502', nombre: 'Otros Servicios Ambulantes' },
  { codigo: '628', nombre: 'Periodista' },
  { codigo: '2', nombre: 'Personal De FFAA O Policia.' },
  { codigo: '411', nombre: 'Personal De Servicio Público' },
  { codigo: '414', nombre: 'Personal Seguridad/Vigilante' },
  { codigo: '412', nombre: 'Pescador/Cazador' },
  { codigo: '409', nombre: 'Peón/Trabajador Agropecuario' },
  { codigo: '629', nombre: 'Pintor/Artista Plástico' },
  { codigo: '204', nombre: 'Prestamista' },
  { codigo: '108', nombre: 'Profesor' },
  { codigo: '303', nombre: 'Promotor/Impulsador' },
  { codigo: '410', nombre: 'Personal de Limpieza/Reparación de Hogar' },
  { codigo: '631', nombre: 'Psicólogo' },
  { codigo: '632', nombre: 'Publicista' },
  { codigo: '205', nombre: 'Recepcionista/Telefonista' },
  { codigo: '633', nombre: 'Redactor' },
  { codigo: '716', nombre: 'Sastre / Costurero' },
  { codigo: '207', nombre: 'Secretaria' },
  { codigo: '800', nombre: 'Sin Cargo' },
  { codigo: '634', nombre: 'Sociólogo / Antropólogo' },
  { codigo: '105', nombre: 'Supervisor/Coordinador/Controlador' },
  { codigo: '106', nombre: 'Tesorero' },
  { codigo: '413', nombre: 'Trab.Minería/Hidrocarburos' },
  { codigo: '635', nombre: 'Traductor De Idiomas' },
  { codigo: '701', nombre: 'Técnico Agropecuario' },
  { codigo: '715', nombre: 'Técnico/Auxiliar De Profesional' },
  { codigo: '503', nombre: 'Vendedor Ambulante' },
  { codigo: '304', nombre: 'Vendedor Comision/No Ambulante.' },
  { codigo: '636', nombre: 'Veterinario/Zoólogo/Zootécnico' }
];
